export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7ff26e17eb589745e03f0f08347f08357414f02edb&name=apiMindbox!'